module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || '57t8c55i',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
